import { saveAs } from 'file-saver';
import * as XLSX from '@e965/xlsx';
import Papa from 'papaparse';
import { mapKeys } from 'lodash';
import { Column } from '../model/table';
import { LogsDto } from '../dtos/logs.dto';

export const exportData = <T>(data: T[], format: string, fileName: string, columnConfigByType: Column<LogsDto>[]) => {
    const keyMapping = new Map<string, string>(
        columnConfigByType.map(col => [col.accessor, col.header])
    );

    const getMappedKey = (field: string) => {
        return keyMapping.get(field) || field;
    };

    const formattedData = data.map((item: any) =>
        mapKeys(item, (value, key: string) => getMappedKey(key))
    );

    if (format === 'json') {
        const jsonString = JSON.stringify(formattedData);
        const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8' });
        saveAs(blob, `${fileName}.json`);
    } else if (format === 'csv') {
        const csvString = Papa.unparse(formattedData);
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, `${fileName}.csv`);
    } else if (format === 'xlsx') {
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }
};